module.exports = __webpack_public_path__ + "01_medium_grey.b78f189f.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer5/01_medium_grey.png
// module id = DL4U
// module chunks = 0